var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpticLogod36921A8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 256,
    viewBox: "0 0 672 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9765_2632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4973 48.2C114.397 48.2 140.397 73.7999 140.397 109.4C140.397 145.1 114.297 170.6 78.4973 170.6C42.7973 170.6 16.6973 145 16.6973 109.4C16.6973 73.6999 42.7973 48.2 78.4973 48.2ZM78.4973 70.5C56.6973 70.5 42.5973 87.1999 42.5973 109.4C42.5973 131.4 56.5973 148.3 78.4973 148.3C100.297 148.3 114.497 131.4 114.497 109.4C114.497 87.1999 100.297 70.5 78.4973 70.5Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.197 50.0999H213.597C239.297 50.0999 253.397 67.4998 253.397 88.2998C253.397 108.9 239.197 126.1 213.597 126.1H183.397V168.5H158.197V50.0999ZM210.197 71.7999H183.397V104.5H210.197C220.097 104.5 227.597 98.0999 227.597 88.1999C227.597 78.3999 220.097 71.7999 210.197 71.7999Z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.297 72.2999H261.697V50.0999H356.097V72.2999H321.697V168.5H296.297V72.2999Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.197 50.0999H397.397V168.5H372.197V50.0999Z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.097 128.4C510.397 140.4 499.197 148.2 484.297 148.2C462.497 148.2 448.297 131.3 448.297 109.3C448.297 87.1 462.497 70.4 484.297 70.4C499.197 70.4 510.497 78.2 516.097 90.2H543.297C535.797 64.8 513.197 48 484.197 48C448.297 48 422.297 73.6 422.297 109.2C422.297 144.9 448.397 170.4 484.197 170.4C513.097 170.4 535.697 153.6 543.297 128.2H516.097V128.4Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.697 206.5H329.497L327.897 210.7H323.797L332.197 188.8H336.897L345.297 210.7H341.197L339.697 206.5ZM330.597 203.1H338.697L334.697 192L330.597 203.1Z",
    fill: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.397 203.4C359.197 205.3 361.997 207 365.597 207C369.297 207 370.797 205.1 370.797 203.4C370.797 201 368.097 200.3 364.897 199.5C360.697 198.4 355.697 197.2 355.697 191.6C355.697 187.3 359.497 183.9 365.097 183.9C369.097 183.9 372.397 185.2 374.797 187.6L372.197 191C370.197 188.9 367.397 188 364.697 188C361.997 188 360.297 189.3 360.297 191.3C360.297 193.3 362.897 194 365.997 194.8C370.297 195.9 375.297 197.2 375.297 203C375.297 207.4 372.297 211.1 365.297 211.1C360.497 211.1 357.097 209.4 354.797 206.9L357.397 203.4Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.697 191.1C393.297 191.1 396.897 195.5 396.897 201.5V202.5H382.497C382.797 205.4 384.897 207.7 388.497 207.7C390.297 207.7 392.497 207 393.797 205.6L395.697 208.3C393.797 210.1 391.097 211.1 388.097 211.1C382.497 211.1 378.297 207.1 378.297 201.1C378.197 195.6 382.097 191.1 387.697 191.1ZM382.397 199.6H392.897C392.797 197.4 391.297 194.6 387.597 194.6C384.197 194.5 382.597 197.2 382.397 199.6Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.896 184.4H404.996V210.7H400.896V184.4Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.197 184.4H414.297V210.7H410.197V184.4Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.598 184.4H424.198V200.2C424.198 204.4 426.498 207.1 430.798 207.1C435.098 207.1 437.398 204.4 437.398 200.2V184.4H441.998V200.3C441.998 206.8 438.298 211.2 430.898 211.2C423.398 211.2 419.698 206.8 419.698 200.4L419.598 184.4Z",
    fill: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.597 191.1C461.197 191.1 464.797 195.5 464.797 201.5V202.5H450.397C450.697 205.4 452.797 207.7 456.397 207.7C458.197 207.7 460.397 207 461.697 205.6L463.597 208.3C461.697 210.1 458.997 211.1 455.997 211.1C450.397 211.1 446.197 207.1 446.197 201.1C446.197 195.6 450.097 191.1 455.597 191.1ZM450.397 199.6H460.897C460.797 197.4 459.297 194.6 455.597 194.6C452.097 194.5 450.597 197.2 450.397 199.6Z",
    fill: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.797 188.7H491.497V192.1H480.597V197.8H491.297V201.2H480.597V207.3H491.497V210.7H476.797V188.7Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.797 200.7C505.797 198.2 504.597 197.4 502.697 197.4C500.997 197.4 499.497 198.5 498.697 199.5V210.6H495.297V194.7H498.697V196.9C499.697 195.7 501.697 194.3 504.197 194.3C507.497 194.3 509.197 196.1 509.197 199.4V210.6H505.797V200.7Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.297 194.8H514.897L519.397 206.7L523.897 194.8H527.497L521.197 210.7H517.597L511.297 194.8Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.297 190C529.297 188.8 530.297 187.9 531.397 187.9C532.597 187.9 533.497 188.9 533.497 190C533.497 191.2 532.597 192.1 531.397 192.1C530.297 192.1 529.297 191.2 529.297 190ZM529.697 194.8H533.097V210.7H529.697V194.8Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.496 194.8H540.896V197.1C542.096 195.6 543.896 194.4 545.996 194.4V197.8C545.696 197.7 545.396 197.7 544.896 197.7C543.496 197.7 541.596 198.7 540.896 199.8V210.6H537.496V194.8Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.697 202.7C547.697 198.2 550.797 194.4 555.697 194.4C560.697 194.4 563.697 198.2 563.697 202.7C563.697 207.3 560.697 211.1 555.697 211.1C550.797 211.1 547.697 207.3 547.697 202.7ZM560.197 202.7C560.197 199.9 558.597 197.4 555.697 197.4C552.797 197.4 551.197 199.9 551.197 202.7C551.197 205.5 552.797 208 555.697 208C558.597 208 560.197 205.5 560.197 202.7Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.598 200.7C577.598 198.2 576.398 197.4 574.498 197.4C572.798 197.4 571.298 198.5 570.498 199.5V210.6H567.098V194.7H570.498V196.9C571.498 195.7 573.498 194.3 575.998 194.3C579.298 194.3 580.998 196.1 580.998 199.4V210.6H577.598V200.7Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.497 200.3C604.497 198.6 603.797 197.4 601.997 197.4C600.497 197.4 599.096 198.5 598.396 199.5V210.6H594.997V200.2C594.997 198.5 594.296 197.3 592.396 197.3C590.896 197.3 589.497 198.4 588.797 199.4V210.5H585.396V194.6H588.797V196.8C589.397 195.8 591.496 194.2 593.896 194.2C596.196 194.2 597.597 195.4 598.197 197.1C599.097 195.7 601.197 194.2 603.497 194.2C606.397 194.2 607.997 195.8 607.997 199V210.5H604.596L604.497 200.3Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.197 194.4C623.897 194.4 626.897 198.1 626.897 203V203.8H614.897C615.197 206.2 616.897 208.2 619.897 208.2C621.397 208.2 623.197 207.6 624.297 206.5L625.797 208.8C624.297 210.3 621.997 211.1 619.497 211.1C614.797 211.1 611.397 207.8 611.397 202.7C611.297 198.1 614.597 194.4 619.197 194.4ZM614.797 201.4H623.597C623.497 199.5 622.297 197.2 619.197 197.2C616.297 197.2 614.897 199.5 614.797 201.4Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.697 200.7C640.697 198.2 639.497 197.4 637.597 197.4C635.897 197.4 634.397 198.5 633.597 199.5V210.6H630.197V194.7H633.597V196.9C634.597 195.7 636.597 194.3 639.097 194.3C642.397 194.3 644.097 196.1 644.097 199.4V210.6H640.697V200.7Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.096 207V197.8H646.496V194.8H649.096V190.5H652.496V194.8H655.696V197.8H652.496V206.1C652.496 207.2 652.996 208 653.996 208C654.596 208 655.296 207.7 655.496 207.4L656.296 210C655.696 210.6 654.696 211 653.096 211C650.496 211.1 649.096 209.6 649.096 207Z",
    fill: "#86C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.996 59.1C554.996 53.2 559.796 48.5 565.596 48.5C571.496 48.5 576.196 53.2 576.196 59.1C576.196 65 571.496 69.7 565.596 69.7C559.696 69.7 554.996 65 554.996 59.1ZM556.396 59.1C556.396 64.1 560.496 68.3 565.596 68.3C570.596 68.3 574.696 64.2 574.696 59.1C574.696 54 570.596 50 565.596 50C560.496 50 556.396 54 556.396 59.1ZM565.296 60.4H563.096V65.2H561.496V53H566.496C568.596 53 570.296 54.5 570.296 56.7C570.296 59.4 567.896 60.3 567.196 60.3L570.396 65.2H568.396L565.296 60.4ZM563.096 54.5V58.9H566.496C567.596 58.9 568.696 58 568.696 56.8C568.696 55.4 567.596 54.6 566.496 54.6L563.096 54.5Z",
    fill: "#717070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9765_2632",
    x: -3.05078,
    y: 0,
    width: 679,
    height: 264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9765_2632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9765_2632",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpticLogod36921A8);
export default __webpack_public_path__ + "static/media/optic_logo.d36921a8.44e498c66f1bc56689b83db60ffc126e.svg";
export { ForwardRef as ReactComponent };